/**
 * Product Gallery Vertical Thumbnails
 * Adds a vertical thumbnail carousel to product gallery
 */

document.addEventListener('DOMContentLoaded', function() {
  const gallery = document.querySelector('.product-media-gallery');
  if (!gallery) return;

  const slideshow = gallery.querySelector('.slideshow');
  if (!slideshow) return;

  // Get all product media slides
  const slides = slideshow.querySelectorAll('.slideshow__slide');
  if (slides.length <= 1) return;

  // Create thumbnail container
  const thumbnailContainer = document.createElement('div');
  thumbnailContainer.className = 'product-media-gallery__thumbnails';

  // Add class to gallery for styling
  gallery.classList.add('product-media-gallery--vertical-thumbnails');

  // Create thumbnails from slides
  slides.forEach((slide, index) => {
    const mediaContainer = slide.querySelector('.product-media');
    if (!mediaContainer) return;

    const img = mediaContainer.querySelector('img');
    if (!img) return;

    // Create thumbnail button
    const thumbnail = document.createElement('button');
    thumbnail.className = 'product-media-gallery__thumbnail';
    thumbnail.setAttribute('aria-label', `View image ${index + 1}`);
    thumbnail.setAttribute('data-slide-index', index);

    // Clone the image for thumbnail
    const thumbImg = img.cloneNode();
    thumbImg.removeAttribute('sizes');
    thumbImg.removeAttribute('srcset');
    thumbImg.loading = 'lazy';

    // Use a smaller image size for thumbnail
    if (thumbImg.src) {
      thumbImg.src = thumbImg.src.replace(/width=\d+/, 'width=180');
    }

    thumbnail.appendChild(thumbImg);

    // Set first thumbnail as active
    if (index === 0) {
      thumbnail.classList.add('is-active');
    }

    // Add click handler
    thumbnail.addEventListener('click', function() {
      // Remove active class from all thumbnails
      thumbnailContainer.querySelectorAll('.product-media-gallery__thumbnail').forEach(t => {
        t.classList.remove('is-active');
      });

      // Add active class to clicked thumbnail
      thumbnail.classList.add('is-active');

      // Trigger slideshow navigation
      const slideshowComponent = slideshow.querySelector('slideshow-component');
      if (slideshowComponent) {
        // Find and click the appropriate dot/control
        const controls = slideshow.querySelectorAll('.slideshow-controls__button');
        if (controls[index]) {
          controls[index].click();
        } else {
          // Fallback: manually scroll to slide
          const slidesContainer = slideshow.querySelector('.slideshow__slides');
          if (slidesContainer && slides[index]) {
            slides[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
          }
        }
      }
    });

    thumbnailContainer.appendChild(thumbnail);
  });

  // Insert thumbnails before slideshow
  gallery.insertBefore(thumbnailContainer, slideshow);

  // Listen for slideshow changes to update active thumbnail
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-hidden') {
        const slides = slideshow.querySelectorAll('.slideshow__slide');
        slides.forEach((slide, index) => {
          if (slide.getAttribute('aria-hidden') === 'false') {
            // Update active thumbnail
            thumbnailContainer.querySelectorAll('.product-media-gallery__thumbnail').forEach(t => {
              t.classList.remove('is-active');
            });
            const activeThumbnail = thumbnailContainer.querySelector(`[data-slide-index="${index}"]`);
            if (activeThumbnail) {
              activeThumbnail.classList.add('is-active');

              // Scroll thumbnail into view if needed
              const containerRect = thumbnailContainer.getBoundingClientRect();
              const thumbRect = activeThumbnail.getBoundingClientRect();

              if (thumbRect.top < containerRect.top || thumbRect.bottom > containerRect.bottom) {
                activeThumbnail.scrollIntoView({ behavior: 'smooth', block: 'center' });
              }
            }
          }
        });
      }
    });
  });

  // Observe changes to slides
  slides.forEach(slide => {
    observer.observe(slide, { attributes: true });
  });
});